import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '../../components/Button/Button';
import Card from '../../components/Card/Card';
import { saveAs } from 'file-saver';
import LoadingOverlay from 'react-loading-overlay';

import axios from 'axios';
import {
  Routes,
  Route,
  useSearchParams,
  BrowserRouter,
} from 'react-router-dom';
import { useState, useEffect } from 'react';

const PaymentSuccess = () => {
  const [policydetails, setPolicyDetails] = useState([]);
  const [showLoad, setShowLoad] = useState(false);

  const [policyNumbers, setPolicyNumbers] = useState('');
  const handleExportPDF = () => {
    const fileURL =
      '../../assets/Tata AIG Motor Policy Schedule_3187_6100004484-00.pdf';
    const fileName = 'policy.pdf';

    saveAs(fileURL, fileName);
  };

  const url = window.location.href;

  const proposID = url?.split('?proposID=')[1]?.split('?')[0];

  const newPropId = proposID;

  const policyNo = url.includes('Output')
    ? url?.split('?Output=')[1]?.split('?')[0].substring(2, 20)
    : 0;
  const policyNum = Number(policyNo);

  const idNum = Number(newPropId);

  const downloadPolicy = () => {
    setShowLoad(true);

    url.includes('Output')
      ? axios
          .get(
            `https://capi.preprod.eibpl.in/transaction/motor/policy_download/?proposal_id=${idNum}&policy_no=${policyNo}`
          )
          .then((response) => {
            setShowLoad(false);

            const anchor = response.data.url;
            window.location.assign(anchor);
          })
          .catch((error) => {
            setShowLoad(false);
          })
      : axios
          .get(
            `https://capi.preprod.eibpl.in/transaction/motor/policy_download/?proposal_id=${idNum}`
          )
          .then((response) => {
            setShowLoad(false);

            const anchor = response.data.url;
            window.location.assign(anchor);
          })
          .catch((error) => {
            setShowLoad(false);
          });
  };

  useEffect(() => {
    setShowLoad(true);

    {
      url.includes('Output')
        ? axios
            .get(
              `https://capi.preprod.eibpl.in/transaction/motor/policy_download/?proposal_id=${idNum}&policy_no=${policyNo}`
            )
            .then((response) => {
              setPolicyDetails(response.data.policy_Data);
              setShowLoad(false);
            })
            .catch((error) => {
              setShowLoad(false);
            })
        : axios
            .get(
              `https://capi.preprod.eibpl.in/transaction/motor/policy_download/?proposal_id=${idNum}`
            )
            .then((response) => {
              setPolicyDetails(response.data.policy_Data);
              setShowLoad(false);
            })
            .catch((error) => {
              setShowLoad(false);
            });
    }
    axios
      .get(
        `https://capi.preprod.eibpl.in/transaction/motor/Scripts/chola/?proposal_id=1791`
      )
      .then((response) => {
        setShowLoad(false);
      })
      .catch((error) => {
        console.error(error, 'chola');
        setShowLoad(false);
      });
  }, []);

  useEffect(() => {
    setShowLoad(true);

    axios
      .get(
        `https://capi.preprod.eibpl.in/transaction/motor/policy_download/?proposal_id=${idNum}&policy_no=${policyNumbers}`
      )
      .then((response) => {
        setPolicyDetails(response.data.policy_Data);
        setShowLoad(false);
      })
      .catch((error) => {
        setShowLoad(false);
      });
  }, [policyNumbers]);

  return (
    <LoadingOverlay active={showLoad} spinner text="Loading...">
      <div className="w-full flex flex-col gap-11">
        <Card>
          <div className="grid grid-flow-col grid-rows-1 grid-cols-2 gap-10 px-14">
            <div className="flex flex-col items-center">
              <img
                src={require('../../assets/images/policy booked.svg').default}
                alt=""
                className="max-h-[355px] h-[355px] object-contain min-w-[300px]"
              />
              <div className="flex gap-4">
                <button
                  id="downloadBtn"
                  onClick={downloadPolicy}
                  // value="download"
                  className=" flex justify-center items-center bg-[#9ED993] px-4 py-3 rounded-md text-[#03634C] font-semibold"
                >
                  <img
                    className="inline-block max-h-4 max-w-4"
                    src={require('../../assets/images/download.svg').default}
                    alt="Download"
                  />
                  <span className="pl-[10px]">Download Policy</span>
                </button>
                <button className=" flex justify-center items-center bg-[#95C3FF] px-4 py-3 rounded-md text-blue-900 font-semibold">
                  <img
                    className="inline-block max-h-4 max-w-4"
                    src={require('../../assets/images/share icon.svg').default}
                    alt="Download"
                  />
                  <span className="pl-[10px]">Share</span>
                </button>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <div className="flex flex-col gap-6 justify-center items-center">
                <h1 className="text-left font-bold text-[25px] leading-[34px]">
                  Congratulations
                </h1>
                <p className="text-left text-sm pt-4 font-normal">
                  Your policy has been successfully booked!
                </p>
                <div className="text-sm">
                  <div className="flex flex-col gap-[21px] justify-center items-start">
                    <p className="font-bold">
                      <span>Quotation Number:</span>
                      <span>{policydetails.quotationNumber}</span>
                    </p>
                    {[
                      {
                        label: 'Transaction Number',
                        value: policydetails.transaction_id,
                      },
                      {
                        label: 'Policy Number',
                        value: policydetails.policyNumber,
                      },
                      {
                        label: 'Proposal Number',
                        value: policydetails.proposalNumber,
                      },
                      {
                        label: 'Your Premium',
                        value: policydetails.yourPremium,
                      },
                      { label: 'Status', value: policydetails.status },
                    ].map((item, i) => {
                      return (
                        <p className="text-sm">
                          <span className="after:inline-block after:content-[':'] after:mr-2 text-sm font-bold">
                            {item.label}
                          </span>
                          <span>{item.value}</span>
                        </p>
                      );
                    })}
                    <p>
                      Your policy has been sent to ${policydetails.email_id}
                    </p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <Button size={'medium'}>
                    <a href="https://insureefficient.com">Proceed to Home</a>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </LoadingOverlay>
  );
};

export default PaymentSuccess;
